<template>
  <!-- Preview Bar Chart -->
  <b-card
    class="h-100"
    :style="{'background-color': backgroundColor, 'color': sidebarBotFontColor, 'font-family': sidebarBotFontFamily}"
  >
    <ComparisonGraph
      chart-id="preview-comparison-bar-graph"
      :preview="preview"
    />
  </b-card>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import ComparisonGraph from '@/components/public/Charts/ComparisonGraph.vue'
import { StoryKeys } from '@/types'
import { STORY_SETTINGS_CONFIG_KEY } from '@/constants'

const components = {
  ComparisonGraph,
}

const props = {
  previewRotateGraph: {
    type: Boolean,
    default: false,
  },
  previewShowXAxis: {
    type: Boolean,
    default: true,
  },
  previewShowYAxis: {
    type: Boolean,
    default: true,
  },
  previewShowLegend: {
    type: Boolean,
    default: true,
  },
  previewCategories: {
    type: Array,
    default: () => [],
  },
  previewLegenditems: {
    type: Array,
    default: () => [],
  },
}

@Component({ components })
export default class PreviewComparisonGraph extends Vue.extend({ props }) {
  get preview () {
    return {
      rotate: this.previewRotateGraph,
      showXAxis: this.previewShowXAxis,
      showYAxis: this.previewShowYAxis,
      showLegend: this.previewShowLegend,
      categories: this.previewCategories,
      legenditems: this.previewLegenditems,
    }
  }

  get activeTab () {
    return this.$typedStore.public.display.activeTab
  }

  get path () {
    return this.activeTab?.path ?? ''
  }

  get backgroundColor () {
    return this.$typedStore.primary.entities.nodes.colour(this.path)
  }

  get sidebarBotFontColor () {
    return this.$typedStore.primary.app.config[STORY_SETTINGS_CONFIG_KEY][StoryKeys.SIDEBAR_BOT].fontColor
  }

  get sidebarBotFontFamily () {
    return this.$typedStore.primary.app.config[STORY_SETTINGS_CONFIG_KEY][StoryKeys.SIDEBAR_BOT].fontFamily
  }
}

</script>
